import { GetServerSideProps } from 'next'

import CardLists from '@/components/CardLists/CardLists'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import Panels from '@/components/Panels/Panels'
import Tabs from '@/components/Tabs/Tabs'
import { CommandersPageProps } from '@/types/page'
import { serverSidePropsFor } from '@/utils/helpers.server'

const PartnersSubPage = ({ data }: CommandersPageProps) => {
  return (
    <Main artCrop={data.container.json_dict.card.image_uris[0].art_crop}>
      <DefaultHead data={data} />
      <Panels data={data} />
      <Tabs />
      <CardLists
        disabledSortMethods={['percent', 'synergy', 'lift']}
        initCardLists={data.container.json_dict.cardlists}
        labelVariant='directory-count'
      />
    </Main>
  )
}

export const getServerSideProps: GetServerSideProps<CommandersPageProps> = async ({ query, req }) =>
  serverSidePropsFor(
    `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL_CLOUDFLARE}/pages/partners/${query.partner}.json`,
    req.headers,
  )

export default PartnersSubPage
